import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, AfterViewChecked, ChangeDetectorRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts/highcharts-gantt';
import { format, startOfMonth, endOfMonth, isSameDay, differenceInMinutes } from 'date-fns';
import { OrgOverviewService } from 'src/app/modules/organizations/services/org-overview.service';
import { ExtendedOrganizationModel } from 'src/app/core/models/organization.model';

@Component({
  selector: 'app-gannt-view',
  templateUrl: './gannt-view.component.html',
  styleUrls: ['./gannt-view.component.scss']
})
export class GanntViewComponent implements OnInit, OnChanges {

  @ViewChild('divRef', { static: false }) divReference: ElementRef;
  @Input() date: Date = new Date();
  @Input() clinic: ExtendedOrganizationModel;
  appointments: any[];
  appointment: any;
  isLoaded = false;
  dateFormatSafari: any;

  constructor(
    private orgOverviewService: OrgOverviewService,
    private cd: ChangeDetectorRef,
  ) { }

  ngAfterViewInit() {
//    this.getClinicAppointments();
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getClinicAppointments();
  }

  highchartclick(data) {
    Highcharts.ganttChart(this.divReference.nativeElement as HTMLElement, {
      title: {
        text: 'Gantt Chart'
      },
      chart: { renderTo: this.divReference.nativeElement as HTMLElement },
      xAxis: [{
        tickInterval: 1000 * 60 * 60  // Hourly
      }],
      tooltip: {
        formatter: function() {
          let series = this.point as any;
          let string =
          'Patient Group : <b>'+series.name+'</b>'
          +'<br>' +
          'Status: <b>'+series.status+'</b>'
          +'<br>' +
          'vaccine: <b>'+series.vaccine+'</b>'
          +'<br>' +
          'Capacity: <b>'+series.capacity+'</b>'
          +'<br>' +
          'Round 1 Scheduled: <b>'+series.round1Scheduled+'</b>'
          +'<br>' +
          'Round 2 Scheduled: <b>'+series.round2Scheduled+'</b>'
          +'<br>' +
          'Round 1 Completed: <b>'+series.round1Completed+'</b>'
          +'<br>' +
          'Round 2 Completed: <b>'+series.round2Completed+'</b>'
          ;
          return string;
        }
      },
      yAxis: {
        type: 'category',
        grid: {
          columns: [{
            title: {
              text: 'Patient Group',
              y: -18,
              x: -10
            },
            categories: (data.map(s => {
              return s.name;
            }))
          }]
        }
      },
      credits: {
        enabled: false,
      },
      series: [
        {
          name: this.clinic.name,
          type: 'gantt',
          data: data
        }]
    });
  }

  getClinicAppointments() {
    let startDate = this.formatDate(startOfMonth(this.date));
    let endDate = this.formatDate(endOfMonth(this.date));
    this.orgOverviewService.getClinicAppointmentsByDateRange(this.clinic.id, startDate, endDate).subscribe((res) => {
      this.appointments = res
        .map(({ startDate, endDate, ...appointment }) => ({
          start: new Date(startDate),
          end: new Date(endDate),
          title: 'name',
          meta: {
            ...appointment,
          },
        }));
      this.isLoaded = true;
      this.getTodaysAppointment();
    });
  }

  formatDate(date): string {
    return format(date, 'MM/dd/yyyy');
  }

  private getTodaysAppointment() {
    this.appointments.find(app => {
      if (isSameDay(app.start, this.date) && app.meta.isClinicSetup) {
        this.appointment = app;
      }
    });
    if (this.appointment)
      this.createSeries();
  }

  private createSeries() {
    let data = [];
    this.appointment.meta.clinicScheduleResources.forEach((element, index) => {
      let start = new Date(element.startDate);
      let end = new Date(element.endDate);
      let series = {
        id: element.inventoryName,
        name: element.patientGroupName ? element.patientGroupName : 'NA',
        pointWidth: 50,
        shadow: true,
        label: element.inventoryName,
        vaccine: element.inventoryName,
        status: element.status == 'ACTIVE' ? 'Active ' : 'In Active',
        round1 : element.round1Count,
        round2 : element.round2Count,
        round1Scheduled : element.round1ScheduledCount,
        round2Scheduled : element.round2ScheduledCount,
        round1Completed : element.round1CompletedCount,
        round2Completed : element.round2CompletedCount,
        capacity : this.calculateCapacity(start, end, element.patientNumber),
        color: this.getColour(element.inventoryName),
        completed: Math.round(((element.round1CompletedCount + element.round2CompletedCount) / (element.round1Count + element.round2Count) + Number.EPSILON) * 100) / 100,
        start: Date.UTC(start.getUTCFullYear(), start.getMonth(), start.getDate(), start.getHours(), start.getMinutes()),
        end: Date.UTC(end.getUTCFullYear(), end.getMonth(), end.getDate(), end.getHours(), end.getMinutes()),
        y: index
      }
      data.push(series);
    });
    this.highchartclick(data);
    this.cd.detectChanges();
  }

  private getColour(vaccineName): string {
    if (vaccineName == 'Pfizer')
      return '#036FB4';
    else if (vaccineName == 'Moderna')
      return '#F5A623';
    else if (vaccineName == 'AstraZeneca')
      return '#2CC970';
    else
      return '#E74C3C';
  }

  public calculateCapacity(startDate : Date, endDate : Date, patientNumber : number) : number {
    let minutes = differenceInMinutes(endDate, startDate);
    let capacity = 0;
    if (minutes && patientNumber) {
      let hours = minutes / 60;
      capacity = (patientNumber) * hours;
    }
    return capacity
  }

}
